import React, { useEffect, useRef } from 'react';
import axios from 'axios';
import { Icon, TooltipHost, Spinner, SpinnerSize } from '@fluentui/react';
import Api from '../../../services/Api';
import { useState } from 'react';
import { isValidGuid } from '../../../helpers/HelperMethods';

const AddAppPermission = ({appPermission, siteId, refresh, setMessage, setAppPermission, setErrors}) => {
    const cancelToken = axios.CancelToken;

    const cancelSource = useRef(null)
    const [isLoading, setIsLoading] = useState(false)
    const [isAppIdValid, setIsAppIdValid] = useState(false)
    const [validationTriggered, setValidationTriggered] = useState(false)

    useEffect(() => {
        setAppPermission({...appPermission, appDisplayName: ''})

        if (!getAppIdErrors(appPermission.appId))
            validateAppPermissions(appPermission.appId)
    }, [appPermission.appId])

    useEffect(() => {
        if (validationTriggered)
            validateAppInput(appPermission)
    }, [appPermission.appId, appPermission.permission])
    
    
    const getAppIdErrors = (appId) => {
        if (!appId) {
            return 'App ID (ClientId) is required.'
        } else if (!isValidGuid(appId)) {
            return 'App ID (ClientId) must be in GUID format.'
        }
    }

    const getAppPermissionsErrors = (permission) => {
        if (!permission) {
            return 'Permission Type is required.'
        }
    }

    const validateAppInput = (appPermission) => {
        setValidationTriggered(true)

        const appIdError = getAppIdErrors(appPermission.appId)
        const appPermissionError = getAppPermissionsErrors(appPermission.permission)
        
        if (appIdError || appPermissionError) {
            setErrors({appId: appIdError, permission: appPermissionError})

            return false
        }
        else {
            if (isAppIdValid)
                setErrors({})

            return isAppIdValid
        }
    }

    const addAppPermission = () => {
        if (!validateAppInput(appPermission))
            return

        setIsLoading(true);
        setMessage();
        setValidationTriggered(false)

        if (cancelSource.current) {
            cancelSource.current.cancel();
        }
        
        cancelSource.current = cancelToken.source();

        const post = {
            addAppPermission: appPermission,
            id: siteId
        }

        let url = `/AdminUpdateSiteRequest`;

        Api.post(url, post, { cancelToken: cancelSource.current.token})
        .then(res => res.data)
        .then(c => {
            setIsLoading(false);
            refresh(siteId);
        })
        .catch(error => {
            setIsLoading(false);
            console.log(error);
            setMessage(error.response.data.message, true);
        });

        return () => {
            cancelSource.current.cancel();
        }
    }
    
    const validateAppPermissions = async (appId) => {    
        setIsLoading(true)
        setErrors({appId: ''})

        if (cancelSource.current) {
            cancelSource.current.cancel();
        }
        
        cancelSource.current = cancelToken.source();

        Api.get(`EntryValidation/ValidateAppPermissions?appId=${appId}`, { cancelToken: cancelSource.current.token })
        .then(res => res.data)
        .then(res => {  
            setIsLoading(false)
            setAppPermission({...appPermission, appDisplayName: res.appDisplayName})
            setIsAppIdValid(res.isPermissionValid)

            if (!res.appDisplayName) {
                setErrors({appId: `Application with ClientId '${appId}' was not found.`})
            } else if (!res.isPermissionValid) {
                setErrors({appId:`Required Sites.Selected permissions are not properly set for Application '${res.appDisplayName}'`})
            }
        })
        .catch(error => {
            setIsLoading(false)
            console.log(error);
            setMessage(error.response.data.message, true);
        })
    }

    return (
        <div style={containerStyles}>
            {
                isLoading 
                ? <Spinner size={SpinnerSize.medium} styles={actionStyles} />
                : <TooltipHost content="Add Permission" styles={actionStyles} >
                    <Icon style={iconStyles} iconName="Accept" onClick={addAppPermission}/>
                  </TooltipHost>
            }
        </div>
    );
}

const actionStyles = {
    root: {
        margin: 'auto'
    }
}

const containerStyles = {
    display: 'flex',
    height: '100%'
}

const iconStyles = {
    cursor: 'pointer',
    margin: '0 5px',
    fontSize: '16px',
    fontWeight: '600'
}

export default AddAppPermission;


// WEBPACK FOOTER //
// ./src/components/EditSite/SiteEditElements/AddAppPermission.js